import { styled } from "@mui/material/styles";
import clsx from "clsx";
import { isFlownSegment } from "../../../utils";

const ItinerarySegmentSummary = (props) => {
  const { isEmd, segment } = props;
  return (
    <span
      className={clsx(props.className, {
        Flown: !isEmd && isFlownSegment(segment),
        IsRefund: props.isRefund,
      })}
    >
      {segment?.d || ""}
    </span>
  );
};

export default styled(ItinerarySegmentSummary)(
  ({ theme }) => `
  margin-right: 4px;

  &.Flown {
    border-bottom: 3px solid #90ee90;
  }

  &.Flown.IsRefund {
    border: 0px;
  }
`,
);
